import * as apiTo from '@api/api-routes'
import { downloadFile } from '@/lib/generic.utils'

export const exportToExcel = {
  methods: {
    mixinExportToExcel: function(gridOptions, filters, view, fileName, excludeColIds) {
      const filterModel = gridOptions.api.getFilterModel()
      const sortModel = gridOptions.columnApi
        .getColumnState()
        .filter(col => !!col.sort)
        .map(col => ({ colId: col.colId, sort: col.sort }))
      const selectedColumns = gridOptions.columnApi.getAllDisplayedColumns().reduce((acc, curr) => {
        if (excludeColIds && excludeColIds.includes(curr.colId)) return acc
        acc[curr.colId] = curr.colDef.headerName
        return acc
      }, {})

      this.$refs.agGrid.setExportLoadingState(true)
      apiTo
        .getExportLinkForView(view, filters, {
          filterModel,
          sortModel,
          selectedColumns
        })
        .then(response => downloadFile(response, fileName))
        .finally(() => this.$refs.agGrid.setExportLoadingState(false))
    }
  }
}
